import React, { useRef, useState } from "react";
import styles from "./UploadGallery.module.css";
import { SubmitButton, TextComponent } from "../../../../../components";
import uploadImg from "../../../../../assets/uploadImg.png";
import wImg from "../../../../../assets/staticImages/wImg.png";
import { List } from "antd";
import { BiSolidMinusCircle } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { PhotosMiddleware } from "../../../../../Store/Middlewares/PhotosMiddleware";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import VideoThumbnail from "react-video-thumbnail";
import { Video, getThumbnails } from "video-metadata-thumbnails";

import video from "../../../../../assets/staticImages/video.mp4";
const UploadGallery = () => {
  const FileInput = React.useRef();
  const [uploadImage, setuploadImage] = useState(null);
  const [images, setImages] = useState([]);
  const [imagesObj, setImagesObj] = useState([]);
  const [thumbnail, setThumbnail] = useState();
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log("state", state);

  const onPressAddGallery = () => {
    console.log("thumbnail", thumbnail);
    if (imagesObj.length == 0) {
      dispatch(
        showAlert({
          type: "Warning",
          title: "Upload",
          message: "Please select atleast one image",
        })
      );
    } else {
      let data = {
        event_id: state?.event_id,
        media: imagesObj,
        category_id: state?.category?.category_id,
      };
      // console.log("data,", data);
      dispatch(PhotosMiddleware.uploadGallery(data))
        .then((data) => {
          console.log("data", data);
          let updatedData = data?.data?.find(
            (item) => item?.id == state?.category?.category_id
          );
          console.log("updatedData", updatedData);
          navigate(state.screen == "single" ? -2 : -1);
        })
        .catch(() => {});
    }
  };

  const addImage = (e) => {
    e.preventDefault();
    const newImages = [...e.target.files].map((img, i) => {
      const imgType = img?.type?.split("/");
      if (imgType[0] == "video") {
        const getData = async () => {
          try {
            const thumbnails = await getThumbnails(e.target.files[0], {
              quality: 0.6,
            });

            let myFile = new File([thumbnails[1]?.blob], "image.png", {
              type: thumbnails[1]?.blob?.type,
            });
            let obj = {
              // id: i,
              media: img,
              media_type: imgType[0],
              thumbnail: myFile,
            };
            setImagesObj([...imagesObj, obj]);
            return myFile;
          } catch (error) {
            console.log(error);
          }
        };
        getData();

        return {
          // id: i,
          media: img,
          media_type: imgType[0],
          thumbnail: thumbnail,
        };
      } else {
        return {
          // id: i,
          media: img,
          media_type: imgType[0],
          thumbnail: undefined,
        };
      }
    });

    setImagesObj((prev) => [...prev, ...newImages]);
    setuploadImage(null);
  };
  const deleteImage = (index) => {
    console.log("iddddddddd", index);
    let imgObjCpy = [...imagesObj];
    imgObjCpy.splice(index, 1);
    setImagesObj(imgObjCpy);
    // setImagesObj((prevState) => prevState.((data, i) => index != i));
    // alert("deleted");
    console.log("imagessd", images);
  };
  // const renderImages = (item, index) => {
  //   return (
  //     <div className={styles.listItem}>
  //       <img src={URL.createObjectURL(item?.media)} />
  //       {item?.thumbnail && <img src={URL.createObjectURL(item?.thumbnail)} />}

  //       {/* <div className={styles.icon}> */}
  //       <BiSolidMinusCircle
  //         className={styles.icon}
  //         onClick={() => deleteImage(index)}
  //       />
  //       {/* </div> */}
  //     </div>
  //   );
  // };
  const renderVideos = (item, index) => {
    console.log("item", item);
    return (
      <div className={styles.listItem}>
        {item?.thumbnail ? (
          <img src={URL.createObjectURL(item?.thumbnail)} />
        ) : (
          <img src={URL.createObjectURL(item?.media)} />
        )}

        {/* <div className={styles.icon}> */}
        <BiSolidMinusCircle
          className={styles.icon}
          onClick={() => deleteImage(index)}
        />
        {/* </div> */}
      </div>
    );
  };
  return (
    <div className={styles.mainCon}>
      <TextComponent text={"Upload Photo"} textClass={styles.heading} />
      <div className={styles.ImgDiv} onClick={() => FileInput.current.click()}>
        <img src={uploadImg} />
      </div>
      <input
        type="file"
        multiple
        ref={FileInput}
        accept={"image/* | video/*"}
        onChange={(e) => {
          setuploadImage(e.target.files[0]);
          addImage(e);
        }}
        style={{ display: "none" }}
      />
      {/* <List
        className={styles.list}
        grid={{ gutter: 16 }}
        itemLayout="horizontal"
        dataSource={images}
        renderItem={renderImages}
      /> */}
      <List
        className={styles.list}
        grid={{ gutter: 16 }}
        itemLayout="horizontal"
        dataSource={imagesObj}
        renderItem={renderVideos}
      />
      <div className={styles.btn}>
        <SubmitButton
          title={"Add"}
          btnClass={styles.modalBtn}
          // onClick={addImage}
          onClick={onPressAddGallery}
        />
      </div>
    </div>
  );
};

export default UploadGallery;
